


































































import { Component, Vue } from "vue-property-decorator";
import messageService from "@/services/MessageService";
import router from "@/router";
import session from "@/services/SessionService";
import { User } from "@/models/User";

@Component
export default class PasswordChange extends Vue {
  // Message codes
  static PASSWORD_CHANGE_SUCCESS = 1;
  static PASSWORD_CHANGE_FAILURE = 2;

  sessionUser: User | null;
  // Inputs
  loading: boolean = false;
  valid: boolean = false;
  payload = {
    password: "",
    passwordConfirmation: ""
  };
  rules = {
    required: (value: string) => !!value || "El campo es requerido",
    min: (value: string) =>
      (value && value.length >= 6) || "Al menos 6 caracteres",
    match: (value: string) =>
      value == this.payload.password || "Las contraseñas no coinciden"
  };

  constructor() {
    super();
    this.sessionUser = session.getUser();
  }

  /**
   * Submits the new password
   *
   * @param {string} password
   */
  submit(password: string) {
    if (!this.loading && this.valid) {
      this.loading = true;
      session
        .changePassword(password)
        .then(res => {
          session.update();
          router.back();
          messageService.addMessage({
            id: PasswordChange.PASSWORD_CHANGE_SUCCESS,
            type: "success",
            text: "Se ha cambiado la contraseña exitosamente.",
            overrides: true
          });
        })
        .catch(err => {
          messageService.addMessage({
            id: PasswordChange.PASSWORD_CHANGE_FAILURE,
            type: "error",
            text: "Ha ocurrido un error. Intente nuevamente.",
            overrides: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
